import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import EmptyList from 'shared/components/table/components/empty-list';
import { InstanceForPaginationType } from 'shared/components/table/types/instance-interface';
import { ACTION_KEY } from '../constants';
import { BaseTableProps } from './base-table';
import TableRow from './table-row';
import { TableSkeleton } from './table-skeleton';
import { twMerge } from 'tailwind-merge';
export interface TableRowsProps<T> extends Pick<BaseTableProps<T>, 'data' | 'columns' | 'testAttributePostfix' | 'type' | 'noHeader' | 'firstLineRect' | 'emptyListWithTitles' | 'onRowClick' | 'nestedId' | 'paginationIdField' | 'rowIdParser' | 'limiter' | 'withBorders' | 'isSortable'> {
  totalWidth: number;
  className?: string | ((instance: T) => string);
}
export function TableRows(t0) {
  const $ = _c(20);
  const {
    data,
    columns,
    type,
    testAttributePostfix,
    totalWidth,
    noHeader,
    firstLineRect,
    onRowClick,
    emptyListWithTitles,
    nestedId,
    paginationIdField,
    rowIdParser,
    limiter,
    withBorders,
    isSortable,
    className
  } = t0;
  if (data === undefined) {
    const t1 = limiter?.limit;
    let t2;
    if ($[0] !== columns || $[1] !== t1 || $[2] !== totalWidth) {
      t2 = <TableSkeleton limit={t1} columns={columns} totalWidth={totalWidth} />;
      $[0] = columns;
      $[1] = t1;
      $[2] = totalWidth;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  } else {
    let t1;
    if ($[4] !== className || $[5] !== columns || $[6] !== data || $[7] !== emptyListWithTitles || $[8] !== firstLineRect || $[9] !== isSortable || $[10] !== nestedId || $[11] !== noHeader || $[12] !== onRowClick || $[13] !== paginationIdField || $[14] !== rowIdParser || $[15] !== testAttributePostfix || $[16] !== totalWidth || $[17] !== type || $[18] !== withBorders) {
      t1 = emptyListWithTitles && data.items.length === 0 ? <div className="bg-background-secondary"><EmptyList /></div> : <div data-test="table-rows">{data.items.map((row, index) => <TableRow key={`row-${JSON.stringify(row)}`} data={data} testAttributePostfix={testAttributePostfix} noHeader={noHeader} firstLineRect={firstLineRect} onRowClick={onRowClick} nestedId={nestedId} paginationIdField={paginationIdField} rowIdParser={rowIdParser} withBorders={withBorders} row={row} index={index} isSortable={isSortable} className={className} data-test={`table-row-${index}`}>{columns.map((column, index2) => {
            if (!column.widthPercent && column.key !== ACTION_KEY) {
              column.widthPercent = 25;
            }
            const keys = (column.key as string).split(".");
            let content = undefined;
            keys.forEach(key => {
              content = !!content ? (content as T)[key as keyof T] : row[key as keyof T];
            });
            const onRenderSmall = column.onRenderSmall ? column.onRenderSmall(row) : column.onRender ? column.onRender(row) : content;
            const onRender = column.onRender ? column.onRender(row) : content;
            const flexValue = column.key === ACTION_KEY ? "0" : column.widthPercent ? `${column.widthPercent / totalWidth * 100}` : "";
            const node = <><div className={`flex flex-wrap items-center lg:hidden ${column.key !== ACTION_KEY && "gap-3"} ${column.className || ""}`}>{column.onRenderSmall ? onRenderSmall : <><span className="text-text-primary whitespace-nowrap font-bold">{column.header}</span>{onRender}</>}</div><div className="hidden lg:block">{onRender}</div></>;
            const isFirst = index2 === 0;
            const isLast = index2 === columns.length - 1;
            return <div key={`cell-${index2}`} className={twMerge("lg:px-4", isFirst && "lg:pl-6", isLast && "lg:pr-6", type === "large" ? "lg:py-4" : "lg:py-2.5", column.key === ACTION_KEY ? "w-full lg:w-0" : "w-full truncate", column.className)} style={{
              width: `${column.key === ACTION_KEY ? "fit-content" : ""}`,
              flex: flexValue
            }}>{node as ReactNode}</div>;
          })}</TableRow>)}</div>;
      $[4] = className;
      $[5] = columns;
      $[6] = data;
      $[7] = emptyListWithTitles;
      $[8] = firstLineRect;
      $[9] = isSortable;
      $[10] = nestedId;
      $[11] = noHeader;
      $[12] = onRowClick;
      $[13] = paginationIdField;
      $[14] = rowIdParser;
      $[15] = testAttributePostfix;
      $[16] = totalWidth;
      $[17] = type;
      $[18] = withBorders;
      $[19] = t1;
    } else {
      t1 = $[19];
    }
    return t1;
  }
}